import { useParams } from 'react-router-dom'
import ModalCEWarehouseProduct from './ModalCEWarehouseProduct'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { DisplayPriceGettingParams } from '../../../../../../../../baseComponents/Displays/DisplayPrice'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, EditRow, ShowRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderStock, CustomRenderStockReserved } from '../../../../../../../../specificComponents/Stock/customRenderStock'
import { StockParentExtendedTy } from '../../../../../../../../specificComponents/Stock/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import ModalCheckProductStock from '../../../../../../../../specificComponents/Stock/ModalCheckProductStock'

interface WarehouseProductsProps extends ComponentWithPermissions {
    basicData?: TwinDictionary
}

const WarehouseProducts: React.FC<WarehouseProductsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const pageData = {
        title: t('warehouseProducts', 'Productos en este Almacén'),
        newText: t('addStockToWarehouse', 'Añadir inventario')
    }

    return (
        <BaseScreenTableInner TableComponent={TableWarehouseProducts} extraWhereParams={{ 'WarehouseId': id, 'MirrorStockParentId': null }} pageData={pageData} CreateModalComponent={ModalCEWarehouseProduct} EditModalComponent={ModalCEWarehouseProduct} DeleteModalComponent={ModalCheckProductStock} userPermissions={userPermissions} basicData={basicData} />
    )
}

interface TableWarehouseProductsProps extends TableComponentBaseScreenInnerProps {
}

const TableWarehouseProducts: React.FC<TableWarehouseProductsProps> = ({ setTableInstance, extraWhereParams, setOpened }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<StockParentExtendedTy> = [
        {
            id: 'ProductId',
            dataKey: 'ProductId',
            label: t('productId', 'ID'),
            hideColumnByDefault: true,
            sortable: true
        },
        {
            id: 'reference',
            dataKey: 'ProductId',
            label: t('reference', 'Referencia'),
            minWidth: 140,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.Product?.reference} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('reference', 'Referencia') }
            },
            sortable: true,
            searchKey: 'Product.reference',
            sortKey: 'Product.reference',
        },
        {
            id: 'name',
            dataKey: 'ProductId',
            label: t('name', 'Nombre'),
            minWidth: 130,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.Product?.ProductLangs?.[0].name} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            sortable: true,
            searchKey: 'Product.ProductLangs.name',
            sortKey: 'Product.ProductLangs.name'
        },
        {
            id: 'location',
            dataKey: 'location',
            label: t('location', 'Localización'),
        },
        {
            id: 'minimum',
            dataKey: 'minimum',
            label: t('minimum', 'Mínimo'),
            hideColumnByDefault: true
        },
        {
            id: 'optimum',
            dataKey: 'optimum',
            label: t('optimum', 'Óptimo'),
            hideColumnByDefault: true
        },
        {
            id: 'stock',
            dataKey: 'stock',
            label: t('stock', 'Inventario'),
            customRender: (parameterValue, allRowData) =><CustomRenderStock allRowData={allRowData} />,
        },
        {
            id: 'reservedUnits',
            dataKey: 'stock',
            label: t('reservedUnits', 'Unidades reservadas'),
            minWidth: 150,
            customRender: (parameterValue, allRowData) =><CustomRenderStockReserved allRowData={allRowData} />,
        },
        {
            id: 'averageUnitPrice',
            dataKey: 'stock',
            label: t('averageUnitPrice', 'Precio medio unitario'),
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={allRowData?.StockHistorys?.length ? allRowData?.StockHistorys[allRowData?.StockHistorys?.length - 1]?.averageStockCost : '0'} CurrencyId={allRowData.CurrencyId} with_vat={false} />,
            havePermission: permissionCheck(getUserPermissions('warehouse.stock.costs'), 'read'),
            hideColumnByDefault: true
        },
        {
            id: 'averageMeasurePrice',
            dataKey: 'stock',
            label: t('averageMeasurePrice', 'Precio medio medida'),
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={allRowData?.StockHistorys?.length ? allRowData?.StockHistorys[allRowData?.StockHistorys?.length - 1]?.averageMeasurePrice : '0'} CurrencyId={allRowData.CurrencyId} with_vat={false} />,
            havePermission: permissionCheck(getUserPermissions('warehouse.stock.costs'), 'read'),
            hideColumnByDefault: true
        },
        {
            id: 'totalValueStock',
            dataKey: 'stock',
            label: t('totalValueStock', 'Valor total stock'),
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={allRowData?.StockHistorys?.length ? allRowData?.StockHistorys[allRowData?.StockHistorys?.length - 1]?.totalStockCost : '0'} CurrencyId={allRowData.CurrencyId} with_vat={false} />,
            havePermission: permissionCheck(getUserPermissions('warehouse.stock.costs'), 'read'),
            hideColumnByDefault: true
        },
        {
            id: 'show',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('see', 'Ver'),
            customRender: (parameterValue, allRowData) => <ShowRow key={'show' + parameterValue} {...{ parameterValue, allRowData }} onClick={(e) => setOpened({
                type: 'delete',
                allRowData: allRowData
            })
            } />
        },
        {
            id: 'edit',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(v, allRowData, e) => {
                e.stopPropagation()
                e.preventDefault()
                setOpened({
                    type: 'edit',
                    allRowData: allRowData
                })
            }} />
        },
    ]
    return (
        <TwinTable name='warehouseProducts' columns={columns} getDataFrom='/api/app/product/stock/getAllStockParentsComplete'
            onRowClick={(_id, rowData) => setOpened({
                type: 'delete',
                allRowData: rowData
            })}
            setTableInstance={setTableInstance} extraWhereParams={extraWhereParams}
        />
    )
}

export default WarehouseProducts